import { SupportWrapper } from "@features/support";
import TutorWrapper from "@features/tutor/components/TutorWrapper";
import { NotificationsProvider } from "@shared/context/NotificationsContext";
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Protected route component that checks for authentication
 * Redirects to login page if user is not authenticated
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const auth = useContext(AuthContext);
  const location = useLocation();

  if (!auth || auth.isInitializing) {
    return null;
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return (
    <TutorWrapper>
      <SupportWrapper>
        <NotificationsProvider>{children}</NotificationsProvider>
      </SupportWrapper>
    </TutorWrapper>
  );
};

export default ProtectedRoute;
